function initCookieBanner() {
  const cookieBanner = document.querySelector(".cookie-banner");
  const cookieBannerClose = document.querySelector(".cookie-banner__button");

  if (cookieBanner) {
    cookieBannerClose.addEventListener("click", () => {
      cookieBanner.classList.add("cookie-banner--closed");
      localStorage.setItem("cookie-banner-closed", "true");
    });

    if (localStorage.getItem("cookie-banner-closed")) {
      cookieBanner.classList.add("cookie-banner--closed");
    } else {
      cookieBanner.classList.remove("cookie-banner--closed");
    }
  }
}

export {initCookieBanner};